import './App.css'
import {Component} from 'react'
import {Route, Switch} from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import LoginRoute from './components/LoginRoute'
import HomeRoute from './components/HomeRoute'
import VideoItemDetailsRoute from './components/VideoItemDetailsRoute'
import TrendingRoute from './components/TrendingRoute'
import GamingRoute from './components/GamingRoute'
import SavedVideos from './components/SavedVideos'
import NotFoundRoute from './components/NotFoundRoute'

class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/login" component={LoginRoute} />

        {/* Protected routes will have header + sidebar + content */}
        <ProtectedRoute exact path="/" component={HomeRoute} />
        <ProtectedRoute
          exact
          path="/videos/:id"
          component={VideoItemDetailsRoute}
        />
        <ProtectedRoute exact path="/trending" component={TrendingRoute} />
        <ProtectedRoute exact path="/gaming" component={GamingRoute} />
        <ProtectedRoute exact path="/saved-videos" component={SavedVideos} />
        <Route path="*" component={NotFoundRoute} />
      </Switch>
    )
  }
}

export default App
